import { makeApi, Zodios, type ZodiosOptions } from "@zodios/core";
import { z } from "zod";

const uploadedMediaAuth_Body = z
  .object({ mediaURL: z.string().nullable(), usdoID: z.number().nullable() })
  .partial()
  .passthrough();
const authTwofactorRecovery_Body = z
  .object({ recoveryCode: z.string(), twoFAToken: z.string() })
  .passthrough();
const authTwofactorVerify_Body = z
  .object({ code: z.string(), twoFAToken: z.string() })
  .passthrough();
const authPasswordRecover_Body = z
  .object({
    AccessModel: z.string().nullish(),
    applID: z.string(),
    email: z.string(),
    resetURL: z.string().nullish(),
  })
  .passthrough();
const authPasswordReset_Body = z
  .object({ password: z.string(), verification: z.string() })
  .passthrough();
const authLogin_Body = z
  .object({
    applID: z.string(),
    coord: z.string().nullish(),
    deviceID: z.string(),
    deviceName: z.string(),
    email: z.string(),
    ip: z.string(),
    location: z.string(),
    password: z.string(),
    rememberMe: z.boolean(),
  })
  .passthrough();
const authEmailTokenAuth_Body = z
  .object({ applID: z.string(), email: z.string() })
  .passthrough();
const authEmailTokenSignin_Body = z
  .object({
    acveID: z.string(),
    coord: z.string().nullish(),
    deviceID: z.string(),
    deviceName: z.string(),
    ip: z.string(),
    location: z.string(),
    verification: z.string(),
  })
  .passthrough();
const documentCreate_Body = z
  .object({
    data: z.unknown(),
    description: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
  })
  .passthrough();
const authCreateAccount_Body = z
  .object({
    applID: z.string(),
    coord: z.string().nullish(),
    deviceID: z.string(),
    deviceName: z.string(),
    email: z.string(),
    ip: z.string(),
    location: z.string(),
    name: z.string(),
    password: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_GeoLocationView = z
  .object({
    address: z
      .object({
        cep: z.string().nullish(),
        city: z.string(),
        complement: z.string().nullish(),
        coordinate: z.string(),
        country: z.string(),
        district: z.string().nullish(),
        number: z.string().nullish(),
        state: z.string(),
        stateAcronym: z.string(),
        street: z.string().nullish(),
      })
      .passthrough(),
    addressFormatted: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractDate = z
  .object({
    acdaID: z.string(),
    arcoID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    occursAt: z.string(),
    updatedAt: z.string(),
    venue: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractLog = z
  .object({
    acloID: z.string(),
    arcoID: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    eventType: z.string(),
    message: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractView = z
  .object({
    agency: z.string(),
    arcoID: z.string(),
    attrID: z.string(),
    attractionName: z.string().nullish(),
    attractionStatus: z.string().nullish(),
    blockingItems: z.array(z.string()).nullish(),
    cievID: z.string(),
    code: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    dates: z
      .array(
        github_com_falqondev_cidade360_backend_service_ArtisticContractDate
      )
      .nullish(),
    deadlineExpired: z.boolean(),
    deletedAt: z.string().nullish(),
    eventName: z.string().nullish(),
    finalizationDeadline: z.string(),
    logs: z
      .array(github_com_falqondev_cidade360_backend_service_ArtisticContractLog)
      .nullish(),
    requestedAmount: z.string(),
    spplID: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusID: z.string().nullish(),
    supplierDocument: z.string().nullish(),
    supplierName: z.string().nullish(),
    supplierStatus: z.string().nullish(),
    updatedAt: z.string(),
    venue: z.string(),
  })
  .passthrough();
const supplierSubmitMyArtisticContractCorrection_Body = z
  .object({ detail: z.string(), expectedStatusID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionClippingLink = z
  .object({
    acliID: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    label: z.string().nullish(),
    orderIndex: z.number(),
    updatedAt: z.string(),
    url: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionDocument = z
  .object({
    atdoID: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documentType: z.string(),
    filePath: z.string(),
    updatedAt: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionFiscalValue = z
  .object({
    afvaID: z.string(),
    amount: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    position: z.number(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionView = z
  .object({
    attrID: z.string(),
    attractionType: z.string(),
    clippingLinks: z
      .array(
        github_com_falqondev_cidade360_backend_service_AttractionClippingLink
      )
      .nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documents: z
      .array(github_com_falqondev_cidade360_backend_service_AttractionDocument)
      .nullish(),
    fiscalAverage: z.string(),
    fiscalValues: z
      .array(
        github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
      )
      .nullish(),
    missingDocumentTypes: z.array(z.string()).nullish(),
    name: z.string(),
    registryStatus: z.string().nullish(),
    spplID: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusID: z.string().nullish(),
    supplierDocument: z.string().nullish(),
    supplierName: z.string().nullish(),
    updatedAt: z.string(),
    videoUrl: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionClippingLinkForm =
  z.object({ label: z.string().nullish(), url: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionFiscalValueForm =
  z.object({ amount: z.string() }).passthrough();
const supplierCreateAttraction_Body = z
  .object({
    attractionType: z.string(),
    clippingLinks: z
      .array(
        github_com_falqondev_cidade360_backend_service_AttractionClippingLinkForm
      )
      .nullish(),
    fiscalValues: z
      .array(
        github_com_falqondev_cidade360_backend_service_AttractionFiscalValueForm
      )
      .nullish(),
    name: z.string(),
    videoUrl: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionDocumentView = z
  .object({
    atdoID: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documentType: z.string(),
    filePath: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusID: z.string().nullish(),
    updatedAt: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const supplierPersistAttractionDocument_Body = z
  .object({
    documentType: z.string(),
    filePath: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierBank = z
  .object({
    code: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    name: z.string(),
    subaID: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType =
  z
    .object({ bstpID: z.string(), doctID: z.string(), sbtdID: z.string() })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessType = z
  .object({
    bstpID: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    isFisicaDefault: z.boolean(),
    label: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassRelation = z
  .object({ label: z.string(), rltnID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClass = z
  .object({
    clasID: z.string(),
    code: z.string(),
    label: z.string(),
    scsgID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentTypeLookup =
  z
    .object({
      deletedAt: z.string().nullish(),
      doctID: z.string(),
      label: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentView = z
  .object({
    createdAt: z.string(),
    doctID: z.string(),
    filePath: z.string(),
    spdcID: z.string(),
    spplID: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    updatedAt: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const supplierPersistUploadedDocument_Body = z
  .object({
    doctID: z.string(),
    filePath: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenalty = z
  .object({
    complement: z.string().nullish(),
    contractNumber: z.string().nullish(),
    createdAt: z.string(),
    decisionType: z.string().nullish(),
    deletedAt: z.string().nullish(),
    description: z.string().nullish(),
    dom: z.string(),
    endDate: z.string(),
    legalBasis: z.string(),
    legalBasisDescription: z.string().nullish(),
    pennID: z.string(),
    process: z.string(),
    publishingDate: z.string(),
    sanctionType: z.string(),
    scopID: z.string(),
    spplID: z.string(),
    startDate: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string().nullish(),
    label: z.string(),
    scopID: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassEntry = z
  .object({ clasID: z.string(), description: z.string(), rltnID: z.string() })
  .passthrough();
const supplierRegister_Body = z
  .object({
    accountEmail: z.string(),
    accountPassword: z.string(),
    additionalAddressInfo: z.string(),
    address: z.string(),
    addressNumber: z.number().nullish(),
    branch: z.string(),
    bstpID: z.string().nullish(),
    checkingAccount: z.string(),
    city: z.string(),
    classes: z.array(
      github_com_falqondev_cidade360_backend_service_SupplierClassEntry
    ),
    cnpj: z.string(),
    coord: z.string().nullish(),
    country: z.string(),
    cpf: z.string(),
    deviceID: z.string(),
    deviceName: z.string(),
    email: z.string(),
    firstName: z.string(),
    ip: z.string(),
    lastName: z.string(),
    legalName: z.string(),
    location: z.string(),
    municipalRegistration: z.string(),
    neighborhood: z.string(),
    personType: z.string(),
    phone: z.string(),
    postalCode: z.string(),
    state: z.string(),
    stateRegistration: z.string(),
    subaID: z.string().nullish(),
    tradeName: z.string(),
  })
  .passthrough();
const supplierUpdateMyRegistry_Body = z
  .object({
    additionalAddressInfo: z.string(),
    address: z.string(),
    addressNumber: z.number().nullish(),
    branch: z.string(),
    bstpID: z.string().nullish(),
    checkingAccount: z.string(),
    city: z.string(),
    classes: z.array(
      github_com_falqondev_cidade360_backend_service_SupplierClassEntry
    ),
    cnpj: z.string(),
    country: z.string(),
    cpf: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    legalName: z.string(),
    municipalRegistration: z.string(),
    neighborhood: z.string(),
    personType: z.string(),
    phone: z.string(),
    postalCode: z.string(),
    state: z.string(),
    stateRegistration: z.string(),
    subaID: z.string().nullish(),
    tradeName: z.string(),
  })
  .passthrough();
const surveyResponse_Body = z
  .object({
    clientDevice: z.string(),
    clientIP: z.string(),
    clientUID: z.string(),
    docuID: z.string().nullish(),
    document: z
      .object({
        data: z.unknown(),
        description: z.string(),
        doteID: z.string(),
        formSchema: z.unknown(),
        permissionMode: z.string(),
        printSchema: z.unknown(),
        title: z.string(),
        uiSchema: z.unknown(),
      })
      .passthrough()
      .nullish(),
    doteID: z.string(),
    metadata: z.unknown(),
    sursID: z.string(),
    survID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyForm = z
  .object({
    deletedAt: z.string().nullish(),
    doteID: z.string(),
    position: z.number(),
    survID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PendingTerm = z
  .object({ slug: z.string(), termID: z.number(), title: z.string() })
  .passthrough();
const usersGetProfileMe_Body = z
  .object({
    avatar: z.string().nullable(),
    info: z.object({ tourCompleted: z.boolean() }).passthrough().nullable(),
    name: z.string().nullable(),
    phone: z.string().nullable(),
  })
  .partial()
  .passthrough();

export const schemas = {
  uploadedMediaAuth_Body,
  authTwofactorRecovery_Body,
  authTwofactorVerify_Body,
  authPasswordRecover_Body,
  authPasswordReset_Body,
  authLogin_Body,
  authEmailTokenAuth_Body,
  authEmailTokenSignin_Body,
  documentCreate_Body,
  authCreateAccount_Body,
  github_com_falqondev_cidade360_backend_service_GeoLocationView,
  github_com_falqondev_cidade360_backend_service_ArtisticContractDate,
  github_com_falqondev_cidade360_backend_service_ArtisticContractLog,
  github_com_falqondev_cidade360_backend_service_ArtisticContractView,
  supplierSubmitMyArtisticContractCorrection_Body,
  github_com_falqondev_cidade360_backend_service_AttractionClippingLink,
  github_com_falqondev_cidade360_backend_service_AttractionDocument,
  github_com_falqondev_cidade360_backend_service_AttractionFiscalValue,
  github_com_falqondev_cidade360_backend_service_AttractionView,
  github_com_falqondev_cidade360_backend_service_AttractionClippingLinkForm,
  github_com_falqondev_cidade360_backend_service_AttractionFiscalValueForm,
  supplierCreateAttraction_Body,
  github_com_falqondev_cidade360_backend_service_AttractionDocumentView,
  supplierPersistAttractionDocument_Body,
  github_com_falqondev_cidade360_backend_service_SupplierBank,
  github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType,
  github_com_falqondev_cidade360_backend_service_BusinessType,
  github_com_falqondev_cidade360_backend_service_SupplierClassRelation,
  github_com_falqondev_cidade360_backend_service_SupplierClass,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentTypeLookup,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentView,
  supplierPersistUploadedDocument_Body,
  github_com_falqondev_cidade360_backend_service_SupplierPenalty,
  github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope,
  github_com_falqondev_cidade360_backend_service_SupplierClassEntry,
  supplierRegister_Body,
  supplierUpdateMyRegistry_Body,
  surveyResponse_Body,
  github_com_falqondev_cidade360_backend_service_SurveyForm,
  github_com_falqondev_cidade360_backend_service_PendingTerm,
  usersGetProfileMe_Body,
};

const endpoints = makeApi([
  {
    method: "post",
    path: "/api/2fa/disable",
    alias: "twofactorDisable",
    description: `Disable 2FA (requires valid TOTP code)`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ code: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ disabled: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/2fa/enable",
    alias: "twofactorEnable",
    description: `Verify TOTP code and activate 2FA`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ code: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ enabled: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/2fa/setup",
    alias: "twofactorSetup",
    description: `Generate TOTP secret and recovery codes for 2FA setup`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                qrCodeURL: z.string(),
                recoveryCodes: z.array(z.string()),
                secret: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/2fa/status",
    alias: "twofactorStatus",
    description: `Get 2FA status for current user`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ enabled: z.boolean(), systemRequired: z.boolean() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth-media",
    alias: "uploadedMediaAuth",
    description: `Authenticate media server access`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: uploadedMediaAuth_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/2fa/recovery",
    alias: "authTwofactorRecovery",
    description: `Use recovery code during login`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authTwofactorRecovery_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/2fa/verify",
    alias: "authTwofactorVerify",
    description: `Verify TOTP code during login`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authTwofactorVerify_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/auth/flow/:provider",
    alias: "auth3rdParty",
    description: `Login with a providers Oauth flow`,
    requestFormat: "json",
    parameters: [
      {
        name: "provider",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "applID",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/auth/flow/:provider/callback",
    alias: "auth3rdParty",
    description: `Login with a providers Oauth flow`,
    requestFormat: "json",
    parameters: [
      {
        name: "provider",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "state",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/one-time-login",
    alias: "authOneTimeLogin",
    description: `Authenticate with single use token`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ token: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/password-recover",
    alias: "authPasswordRecover",
    description: `Start password recovery for account with given email`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authPasswordRecover_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acveID: z.string(),
                createdAt: z.string(),
                type: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/password-reset/:resetID",
    alias: "authPasswordReset",
    description: `Reset password for account with given email`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authPasswordReset_Body,
      },
      {
        name: "resetID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z.object({}).partial().passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/password-reset/:resetID/validate",
    alias: "authPasswordResetValidate",
    description: `Verify that password reset is still valid`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authPasswordReset_Body,
      },
      {
        name: "resetID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ isValid: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/auth/refresh",
    alias: "authRefresh",
    description: `Generate new short-lived JWT for current session user`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/signin",
    alias: "authLogin",
    description: `Login with email &amp; password`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authLogin_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/signout",
    alias: "authSignout",
    description: `Signout and forget session and refresh tokens`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/token-auth",
    alias: "authEmailTokenAuth",
    description: `Start authentication with token for given email`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authEmailTokenAuth_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acveID: z.string(),
                createdAt: z.string(),
                type: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/token-signin",
    alias: "authEmailTokenSignin",
    description: `Authentication with token for given email`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authEmailTokenSignin_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth/validate-email",
    alias: "authValidateEmail",
    description: `checks if the email is valid for appl_id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authEmailTokenAuth_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                email: z.string(),
                isValid: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/document-templates/:doteID",
    alias: "documentTemplateGet",
    description: `Get one document template`,
    requestFormat: "json",
    parameters: [
      {
        name: "doteID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultData: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/documents",
    alias: "documentCreate",
    description: `Create one document`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                data: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/onboarding/create-account",
    alias: "authCreateAccount",
    description: `Create a new account`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: authCreateAccount_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/public-auth-media",
    alias: "mideaServerPublicAuth",
    description: `Public authenticate media server access`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/search/geo-locations",
    alias: "geoLocationList",
    description: `Return a search of GeoLocationView`,
    requestFormat: "json",
    parameters: [
      {
        name: "cep",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_GeoLocationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/artistic-contracts",
    alias: "supplierListMyArtisticContracts",
    description: `List my artistic contracts`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "cievID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ArtisticContractView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/artistic-contracts/:arcoID",
    alias: "supplierGetMyArtisticContract",
    description: `Get one of my artistic contracts`,
    requestFormat: "json",
    parameters: [
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                agency: z.string(),
                arcoID: z.string(),
                attrID: z.string(),
                attractionName: z.string().nullish(),
                attractionStatus: z.string().nullish(),
                blockingItems: z.array(z.string()).nullish(),
                cievID: z.string(),
                code: z.string(),
                createdAt: z.string(),
                createdBy: z.string(),
                dates: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractDate
                  )
                  .nullish(),
                deadlineExpired: z.boolean(),
                deletedAt: z.string().nullish(),
                eventName: z.string().nullish(),
                finalizationDeadline: z.string(),
                logs: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractLog
                  )
                  .nullish(),
                requestedAmount: z.string(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                supplierStatus: z.string().nullish(),
                updatedAt: z.string(),
                venue: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/artistic-contracts/:arcoID/submit-correction",
    alias: "supplierSubmitMyArtisticContractCorrection",
    description: `Submit a contract correction`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierSubmitMyArtisticContractCorrection_Body,
      },
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.string(),
                arcoID: z.string(),
                changedBy: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/attractions",
    alias: "supplierListMyAttractions",
    description: `List my attractions`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "attrID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_AttractionView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/attractions",
    alias: "supplierCreateAttraction",
    description: `Create an attraction`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierCreateAttraction_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attrID: z.string(),
                attractionType: z.string(),
                clippingLinks: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                  )
                  .nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documents: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionDocument
                  )
                  .nullish(),
                fiscalAverage: z.string(),
                fiscalValues: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                  )
                  .nullish(),
                missingDocumentTypes: z.array(z.string()).nullish(),
                name: z.string(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
                videoUrl: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/supplier/attractions/:attrID",
    alias: "supplierDeleteAttraction",
    description: `Delete one of my attractions`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attrID: z.string(),
                attractionType: z.string(),
                clippingLinks: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                  )
                  .nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documents: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionDocument
                  )
                  .nullish(),
                fiscalAverage: z.string(),
                fiscalValues: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                  )
                  .nullish(),
                missingDocumentTypes: z.array(z.string()).nullish(),
                name: z.string(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
                videoUrl: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/attractions/:attrID",
    alias: "supplierGetMyAttraction",
    description: `Get one of my attractions`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attrID: z.string(),
                attractionType: z.string(),
                clippingLinks: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                  )
                  .nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documents: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionDocument
                  )
                  .nullish(),
                fiscalAverage: z.string(),
                fiscalValues: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                  )
                  .nullish(),
                missingDocumentTypes: z.array(z.string()).nullish(),
                name: z.string(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
                videoUrl: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/supplier/attractions/:attrID",
    alias: "supplierUpdateAttraction",
    description: `Update one of my attractions`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierCreateAttraction_Body,
      },
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attrID: z.string(),
                attractionType: z.string(),
                clippingLinks: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                  )
                  .nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documents: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionDocument
                  )
                  .nullish(),
                fiscalAverage: z.string(),
                fiscalValues: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                  )
                  .nullish(),
                missingDocumentTypes: z.array(z.string()).nullish(),
                name: z.string(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
                videoUrl: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/attractions/:attrID/documents",
    alias: "supplierListMyAttractionDocuments",
    description: `List documents for my attraction`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "documentType",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_AttractionDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/attractions/:attrID/documents/:atdoID/media-auth",
    alias: "supplierGetAttractionDocumentMediaAuth",
    description: `Get media auth for an attraction document`,
    requestFormat: "json",
    parameters: [
      {
        name: "atdoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/attractions/:attrID/documents/media-auth",
    alias: "supplierGetAttractionDocumentUploadMediaAuth",
    description: `Get media auth for attraction document upload`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ jwt: z.string(), key: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/attractions/:attrID/documents/persist",
    alias: "supplierPersistAttractionDocument",
    description: `Persist an uploaded attraction document`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierPersistAttractionDocument_Body,
      },
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                atdoID: z.string(),
                attrID: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documentType: z.string(),
                filePath: z.string(),
                updatedAt: z.string(),
                validity: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/attractions/:attrID/submit",
    alias: "supplierSubmitAttraction",
    description: `Submit an attraction for review`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attrID: z.string(),
                attractionType: z.string(),
                clippingLinks: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                  )
                  .nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documents: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionDocument
                  )
                  .nullish(),
                fiscalAverage: z.string(),
                fiscalValues: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                  )
                  .nullish(),
                missingDocumentTypes: z.array(z.string()).nullish(),
                name: z.string(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
                videoUrl: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/banks",
    alias: "supplierListBanks",
    description: `List supplier banks`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "code",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierBank
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/business-type-document-types",
    alias: "supplierListBusinessTypeDocumentTypes",
    description: `List document types linked to a business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "bstpID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "doctID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/business-types",
    alias: "supplierListBusinessTypes",
    description: `List all business types`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "bstpID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BusinessType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/class-relations",
    alias: "supplierListClassRelations",
    description: `List supplier class relation types`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierClassRelation
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/classes",
    alias: "supplierListClasses",
    description: `List supplier classes`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "scsgID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "clasID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierClass
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/document-types",
    alias: "supplierListDocumentTypes",
    description: `List all supplier document types`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "doctID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierDocumentTypeLookup
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/documents",
    alias: "supplierListMyDocuments",
    description: `List my supplier documents`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "doctID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/documents",
    alias: "supplierUploadDocument",
    description: `Upload a supplier document`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                doctID: z.string(),
                filePath: z.string(),
                spdcID: z.string(),
                spplID: z.string(),
                updatedAt: z.string(),
                validity: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/documents/:spdcID/media-auth",
    alias: "supplierGetDocumentMediaAuth",
    description: `Get media auth for a supplier document`,
    requestFormat: "json",
    parameters: [
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/documents/:spdcID/url",
    alias: "supplierGetDocumentURL",
    description: `Get signed download URL for a supplier document`,
    requestFormat: "json",
    parameters: [
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ expiresAt: z.string(), url: z.string() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/documents/media-auth",
    alias: "supplierGetDocumentUploadMediaAuth",
    description: `Get media auth for supplier document upload`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ jwt: z.string(), key: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/documents/persist",
    alias: "supplierPersistUploadedDocument",
    description: `Persist an uploaded supplier document`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierPersistUploadedDocument_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                doctID: z.string(),
                filePath: z.string(),
                spdcID: z.string(),
                spplID: z.string(),
                updatedAt: z.string(),
                validity: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/penalties",
    alias: "supplierListMyPenalties",
    description: `List my supplier penalties`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "process",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "legalName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "document",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "pennID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierPenalty
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/penalty-scopes",
    alias: "supplierListPenaltyScopes",
    description: `List all penalty scopes`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "scopID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier/register",
    alias: "supplierRegister",
    description: `Register a new supplier`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierRegister_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                jwt: z.string(),
                permissions: z.array(z.string()),
                requires2FA: z.boolean().nullish(),
                requires2FASetup: z.boolean().nullish(),
                roles: z.array(z.string()),
                twoFAToken: z.string().nullish(),
                user: z
                  .object({
                    applID: z.string(),
                    avatar: z.string().nullish(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({ tourCompleted: z.boolean() })
                      .passthrough(),
                    name: z.string(),
                    phone: z.string().nullish(),
                    pushTokens: z.array(z.string()).nullish(),
                    userID: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier/registry/me",
    alias: "supplierGetMyRegistry",
    description: `Get my supplier registry`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                additionalAddressInfo: z.string().nullish(),
                address: z.string().nullish(),
                addressNumber: z.number().nullish(),
                bankName: z.string().nullish(),
                branch: z.string().nullish(),
                bstpID: z.string().nullish(),
                businessTypeName: z.string().nullish(),
                checkingAccount: z.string().nullish(),
                city: z.string().nullish(),
                cnpj: z.string().nullish(),
                country: z.string().nullish(),
                cpf: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                firstName: z.string().nullish(),
                lastName: z.string().nullish(),
                legalName: z.string().nullish(),
                municipalRegistration: z.string().nullish(),
                neighborhood: z.string().nullish(),
                personType: z.string(),
                phone: z.string().nullish(),
                postalCode: z.string().nullish(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                state: z.string().nullish(),
                stateRegistration: z.string().nullish(),
                status: z.string(),
                subaID: z.string().nullish(),
                tradeName: z.string().nullish(),
                updatedAt: z.string(),
                userID: z.string().nullish(),
                verifiedEmail: z.boolean().nullish(),
                verifiedPhone: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/supplier/registry/me",
    alias: "supplierUpdateMyRegistry",
    description: `Update my supplier registry`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierUpdateMyRegistry_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                additionalAddressInfo: z.string().nullish(),
                address: z.string().nullish(),
                addressNumber: z.number().nullish(),
                bankName: z.string().nullish(),
                branch: z.string().nullish(),
                bstpID: z.string().nullish(),
                businessTypeName: z.string().nullish(),
                checkingAccount: z.string().nullish(),
                city: z.string().nullish(),
                cnpj: z.string().nullish(),
                country: z.string().nullish(),
                cpf: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                firstName: z.string().nullish(),
                lastName: z.string().nullish(),
                legalName: z.string().nullish(),
                municipalRegistration: z.string().nullish(),
                neighborhood: z.string().nullish(),
                personType: z.string(),
                phone: z.string().nullish(),
                postalCode: z.string().nullish(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                state: z.string().nullish(),
                stateRegistration: z.string().nullish(),
                status: z.string(),
                subaID: z.string().nullish(),
                tradeName: z.string().nullish(),
                updatedAt: z.string(),
                userID: z.string().nullish(),
                verifiedEmail: z.boolean().nullish(),
                verifiedPhone: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/survey/:slug",
    alias: "surveyGet",
    description: `Get one survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "slug",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAt: z.string().nullish(),
                allowedUsers: z.array(z.string()),
                answers: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                descriptionFinished: z.string(),
                displayOptions: z.unknown(),
                drafts: z.number(),
                slug: z.string(),
                survID: z.string(),
                surveyForms: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyForm
                ),
                title: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey/response",
    alias: "surveyResponse",
    description: `answer survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: surveyResponse_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clientDevice: z.string(),
                clientIP: z.string(),
                clientUID: z.string(),
                createdAt: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                metadata: z.unknown(),
                sureID: z.number(),
                sursID: z.string(),
                survID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey/session",
    alias: "surveyCreateSession",
    description: `Create new survey session`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ survID: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                submittedAt: z.string().nullish(),
                sursID: z.string(),
                survID: z.string(),
                userID: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey/submit",
    alias: "surveySubmit",
    description: `submit response`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ sursID: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/term/:slug",
    alias: "termGet",
    description: `Get one term`,
    requestFormat: "json",
    parameters: [
      {
        name: "slug",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                slug: z.string(),
                termID: z.number(),
                title: z.string(),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/term/accept",
    alias: "termAccept",
    description: `Accept a term`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ termID: z.number() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                accepted: z.boolean(),
                termID: z.number(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/term/pending",
    alias: "termGetPending",
    description: `get all pending terms`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                terms: z.array(
                  github_com_falqondev_cidade360_backend_service_PendingTerm
                ),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/users/:userID",
    alias: "usersGetUserByID",
    description: `Return the authenticated user&#x27;s data`,
    requestFormat: "json",
    parameters: [
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                name: z.string(),
                phone: z.string().nullish(),
                pushTokens: z.array(z.string()).nullish(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "patch",
    path: "/api/users/:userID",
    alias: "usersPatchUserByID",
    description: `Update user&#x27;s data`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: usersGetProfileMe_Body,
      },
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                inusID: z.number().nullish(),
                name: z.string(),
                phone: z.string().nullish(),
                userID: z.string(),
                verifiedEmail: z.boolean().nullish(),
                verifiedPhone: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/users/email-verification/confirm",
    alias: "usersEmailVerificationConfirm",
    description: `Confirm the current user&#x27;s email using a verification code`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ code: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ verifiedEmail: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/users/email-verification/request",
    alias: "usersEmailVerificationRequest",
    description: `Send an email verification code to the current user&#x27;s email`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ sent: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/users/phone-verification/confirm",
    alias: "usersPhoneVerificationConfirm",
    description: `Confirm the current user&#x27;s phone using a verification code`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ code: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ verifiedPhone: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/users/phone-verification/request",
    alias: "usersPhoneVerificationRequest",
    description: `Send a phone verification code by SMS to the current user&#x27;s phone`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ sent: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/users/profile/:userID",
    alias: "usersGetProfileMe",
    description: `Get user profile`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: usersGetProfileMe_Body,
      },
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                inusID: z.number().nullish(),
                name: z.string(),
                phone: z.string().nullish(),
                userID: z.string(),
                verifiedEmail: z.boolean().nullish(),
                verifiedPhone: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
]);

export const api = new Zodios(endpoints);

export function createApiClient(baseUrl: string, options?: ZodiosOptions) {
  return new Zodios(baseUrl, endpoints, options);
}
